import {
  INTERESTS,
  QUALIFICATIONS,
  BUDGETS,
} from "../../Data/studentData";
import type { Answers } from "../../types/CourseFinder";
import FormNav from "../FormNav";

function buildWhatsAppLink(answers: Answers): string {
  const interest =
    answers.interests
      .map((id) => INTERESTS.find((i) => i.id === id)?.label || id)
      .join(", ") || "Not specified";
  const qual =
    QUALIFICATIONS.find((q) => q.id === answers.qualification)?.label ||
    answers.qualification ||
    "Not specified";
  const result = answers.resultRange || "Not specified";
  const budget =
    BUDGETS.find((b) => b.id === answers.budget)?.label ||
    answers.budget ||
    "Not specified";
  const msg = `Hi SCS Education, I used the Course Finder. I'm interested in ${interest}. My qualification is ${qual}. My result range is ${result}. My budget is ${budget}. Please help me check suitable courses and universities.`;
  return `https://wa.me/601112870256?text=${encodeURIComponent(msg)}`;
}

export default function CourseFinderNav({ answers }: { answers: Answers }) {
  const waLink = buildWhatsAppLink(answers);
  return <FormNav counsellorHref={waLink} />;
}
